const Play = (props) => (
  <svg
    fill="none"
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* <circle cx="12" cy="12.2002" fill="#bdbdbd" r="12" /> */}
    <path
      d="m18.2568 11.3341c.6667.3849.6667 1.3471 0 1.732l-8.6359 4.986c-.66667.3849-1.5-.0963-1.5-.8661v-9.97188c0-.7698.83333-1.25092 1.5-.86602z"
      fill="currentColor"
    />
  </svg>
);

export default Play;
